export default function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${
        dark ? "bg-navy-deep border-white/10" : "bg-navy border-white/10"
      } py-4 select-none`}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 pr-6 font-display text-xl sm:text-2xl font-semibold uppercase tracking-[0.15em] text-white/70 whitespace-nowrap"
          >
            {item}
            <span className={i % 2 === 0 ? "text-ember" : "text-frost"}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
